exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".res-dialog-list {\n  max-height: 50vh;\n  overflow: auto;\n}\n.res-dialog-list__title {\n  padding: 10px;\n  font-weight: 600;\n  font-size: 1.5em;\n  color: #bc9c9e;\n}\n.res-dialog-list__none {\n  display: block;\n  padding: 28px;\n  font-weight: 600;\n  font-size: 1.5em;\n  color: #bc9c9e;\n  text-align: center;\n}", ""]);

// exports
